import { payloadCodeTypeEnum } from "../../dataStruct";
import { parseCss } from "../../functions";

const PERSON_TYPES: number[] = [
  payloadCodeTypeEnum.crew,
  payloadCodeTypeEnum.pic,
  payloadCodeTypeEnum.fo,
  payloadCodeTypeEnum.pax,
];

/**
 * One row for each person at a seat. A device can hold the crew of an earlier
 * duty sign beside the current one (#963), and each copy was counted and
 * weighed. An active copy wins over an inactive one, else the last copy wins.
 * Two people who share a seat as roster alternatives have different names and
 * both stay. A row with no position stays too.
 *
 * ponytail: a person who changed the seat between two signs is not matched.
 * Match on the name alone if that case shows up.
 */
export function uniqueSeatedPersons<T extends { codeType: any; name: string; parameters: string; active: boolean }>(
  rows: T[]
): T[] {
  const result: T[] = [];
  const indexByKey = new Map<string, number>();
  for (const row of rows) {
    const position = parseCss(row.parameters, "position");
    if (!PERSON_TYPES.includes(Number(row.codeType)) || !position) {
      result.push(row);
      continue;
    }
    const key = JSON.stringify([
      position,
      (row.name ?? "").trim().toLocaleLowerCase(),
      parseCss(row.parameters, "opsMissionType") ?? "",
    ]);
    const index = indexByKey.get(key);
    if (index === undefined) {
      indexByKey.set(key, result.length);
      result.push(row);
    } else if (row.active || !result[index].active) {
      result[index] = row;
    }
  }
  return result;
}
